'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { CheckboxInput as BaseCheckboxInput } from '@lichtblick/photon/molecules/legacy-checkbox/checkbox-input';
import { SelectInput as BaseSelect } from '@lichtblick/photon/molecules/legacy-select-input/select-input';
import { Textfield as BaseTextfield } from '@lichtblick/photon/molecules/legacy-textfield/textfield';
import { useState } from 'react';
import { ComboBoxInput as BaseComboBoxInput } from './combo-box-input/combo-box-input';
const DEFAULT_ERROR_MESSAGE = 'Hier stimmt etwas nicht';
const getErrorMessage = (input, messages)=>{
    const { max, maxLength, min, minLength, step, validity } = input;
    if (validity) {
        switch(true){
            case validity.valid:
                return;
            case validity.patternMismatch:
                return messages?.pattern ?? DEFAULT_ERROR_MESSAGE;
            case validity.rangeOverflow:
                return messages?.max ?? `Der Wert darf nicht größer als ${max} sein`;
            case validity.rangeUnderflow:
                return messages?.min ?? `Der Wert darf nicht kleiner als ${min} sein`;
            case validity.stepMismatch:
                return messages?.step ?? `Der Wert muss ein Vielfaches von ${step} sein`;
            case validity.tooLong:
                return messages?.maxLength ?? `Der Wert darf nicht länger als ${maxLength} Zeichen sein`;
            case validity.tooShort:
                return messages?.minLength ?? `Der Wert darf nicht kürzer als ${minLength} Zeichen sein`;
            case validity.valueMissing:
                return messages?.required ?? 'Hier fehlt noch eine Angabe';
            default:
                return messages?.invalid ?? DEFAULT_ERROR_MESSAGE;
        }
    }
};
// The following HOC contains logic that would probably be easier to read when directly integrated into Input-Components
// rather than a one-fits-all generic solution. But I don't have the time to refactor right now.
const withValidation = (Component)=>({ messages, onBlur, onInput, onInvalid, statusLabel, statusType, ...props })=>{
        const [error, setError] = useState();
        const [isTouched, setIsTouched] = useState(false);
        const validate = (input)=>setError(getErrorMessage(input, messages));
        return /*#__PURE__*/ _jsx(Component, {
            ...props,
            onBlur: (event)=>{
                setIsTouched(true);
                validate(event.target);
                onBlur?.(event);
            },
            onInput: (event)=>{
                if (isTouched || error || event.target.type === 'checkbox') {
                    validate(event.target);
                }
                onInput?.(event);
            },
            onInvalid: (event)=>{
                event.preventDefault();
                validate(event.target);
                onInvalid?.(event);
            },
            statusLabel: error || statusLabel,
            statusType: error ? 'error' : statusType
        });
    };
export const Textfield = withValidation(BaseTextfield);
export const SelectInput = withValidation(BaseSelect);
export const ComboBoxInput = withValidation(BaseComboBoxInput);
export const CheckboxInput = withValidation(({ statusType, ...props })=>/*#__PURE__*/ _jsx(BaseCheckboxInput, {
        hasError: statusType === 'error',
        ...props
    }));

//# sourceMappingURL=input-with-validation.js.map